import { CommonModule, DatePipe } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { NgbDatepickerModule, NgbTimepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { ErrorMessageModule } from '../error-message/error-message.module';
import { TooltipMessageModule } from '../tooltip-message/tooltip-message.module';
import { DateTimePicker } from '../utils/models/DateTimePicker';
import { DateTimePickerComponent } from './date-time-picker.component';
import { DateTimePickerService } from './date-time-picker.service';


@NgModule({
  declarations: [DateTimePickerComponent],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    ErrorMessageModule,
    TooltipMessageModule,
    NgbDatepickerModule,
    MatIconModule,
    MatTooltipModule,
    NgbTimepickerModule
  ],
  exports: [DateTimePickerComponent],
	providers: [
		DatePipe
	]
})
export class DateTimePickerModule { 
  static forRoot(dateTimePicker: DateTimePicker = new DateTimePicker()): ModuleWithProviders<DateTimePickerModule> {
    return {
      ngModule: DateTimePickerModule,
      providers: [
        { provide: 'DATE_TIME_PICKER_INPUT_DATE_TIME_FORMAT', useValue: dateTimePicker.inputDatetimeFormat },
        { provide: 'DATE_TIME_PICKER_SHOW_LABEL', useValue: dateTimePicker.showLabel },
        { provide: 'DATE_TIME_PICKER_OPEN_WHEN_FOCUS', useValue: dateTimePicker.openWhenFocus },
        { provide: 'DATE_TIME_PICKER_GO_NEXT_WHEN_SELECT', useValue: dateTimePicker.goNextWhenSelect },
        { provide: 'DATE_TIME_PICKER_VALIDATOR_MESSAGE', useValue: dateTimePicker.validatorMessage },
        { provide: 'DATE_TIME_PICKER_TOOLTIP_MESSAGE', useValue: dateTimePicker.tooltipMessage },
        { provide: 'DATE_TIME_PICKER_SUBMITTED', useValue: dateTimePicker.submitted },
        DateTimePickerService
      ]
    }
  }
}
